// Zentrale Konfiguration. Werte kommen build-time aus VITE_*-Env (siehe .env.example),
// mit Prod-Defaults als Fallback, damit ein Build ohne .env schon korrekt zeigt.

const env = import.meta.env as Record<string, string | undefined>

const LEGAL_BASE = env.VITE_LEGAL_BASE ?? "https://navigator.sinus-institut.de"

export const CONFIG = {
  keycloakUrl: env.VITE_KEYCLOAK_URL ?? "https://id.sinus-institut.de",
  keycloakRealm: env.VITE_KEYCLOAK_REALM ?? "iso",
  keycloakClient: env.VITE_KEYCLOAK_CLIENT ?? "navigator-app",
  // Leer = same-origin. In Prod proxied APISIX access.sinus-institut.de/billing/* ans Backend.
  apiBase: (env.VITE_API_BASE ?? "").replace(/\/$/, ""),
  // Rechtsseiten (Footer + Consent-Checkbox). Alle drei liegen unter derselben
  // Basis wie die Datenschutzerklaerung; einzeln ueberschreibbar.
  datenschutzUrl: env.VITE_DATENSCHUTZ_URL ?? `${LEGAL_BASE}/datenschutz.html`,
  impressumUrl: env.VITE_IMPRESSUM_URL ?? `${LEGAL_BASE}/impressum.html`,
  agbUrl: env.VITE_AGB_URL ?? `${LEGAL_BASE}/agb.html`,
  // Produktseite fuer "Mehr zum Navigator erfahren" (Website, nicht der Shop).
  navigatorInfoUrl: env.VITE_NAVIGATOR_INFO_URL ?? "https://www.sinus-institut.de/ki-loesungen",
  // Infopaket-Auswahl bei Bundle/Staffel. Default AN: das Backend verarbeitet die
  // Auswahl seit #21 (selected_packages + Bundle-Fulfillment, deployt 2026-08-03).
  packageSelection: (env.VITE_PACKAGE_SELECTION ?? "true").toLowerCase() === "true",
}
